import { Pipe, PipeTransform } from '@angular/core';
import { PhonesService } from '../services/phones.service';

@Pipe({
  name: 'phone',
  standalone: false,
})
export class PhonePipeLib implements PipeTransform {
  constructor(private phonesService: PhonesService) {}
  transform(phoneValue: string): string {
    return this.phonesService.formatPhoneNumber(phoneValue) ?? '';
  }
}
